var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('recaptcha',{attrs:{"siteKey":_vm.appSettings.configs.recaptchaSiteKey,"action":"login"},on:{"validate":_vm.setCaptcha,"error":_vm.captchaError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }